const VALIDATION_MESSAGES = {
  "pretestPrimaryHeatSourceAppliance": "Please select just ONE option for primary heat source appliance.",
  "pretestPrimaryHeatSourceCombType": "Please select just ONE option for primary heat source comb. type.",
  "pretestSecondaryHeatSourceAppliance": "Please select just ONE option for secondary heat source appliance.",
  "pretestSecondaryHeatSourceCombType": "Please select just ONE option for secondary heat source comb. type.",
  "pretestPrimarySelectYesOrNo_1": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_2": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_3": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_4": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_5": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_6": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_7": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_8": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_9": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_10": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_1": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_2": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_3": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_4": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_5": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_6": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_7": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_8": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_9": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_10": "Please select only yes or no.",
  "primaryCorrectionsOneChoice_2": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_3": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_4": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_5": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_7": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_8": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_9": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_10": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_2": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_3": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_4": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_5": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_7": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_8": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_9": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_10": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "pretestOpenDoorPrimaryPPM": "Please only select one primary heat source.",
  "pretestOpenDoorSecondaryPPM": "Please only select one primary heat source.",
  "pretestClosedDoorPrimaryPPM": "Please only select one primary heat source.",
  "pretestClosedDoorSecondaryPPM": "Please only select one primary heat source.",
  "postTestOpenDoorPrimaryPPM": "Please only select one primary heat source.",
  "postTestOpenDoorSecondaryPPM": "Please only select one primary heat source.",
  "postTestClosedDoorPrimaryPPM": "Please only select one primary heat source.",
  "postTestClosedDoorSecondaryPPM": "Please only select one primary heat source.",
  "preTestSpillageOpenDoorOnlyOne": "Please only select one option for draft and spillage results.",
  "preTestSpillageOpenDoor2OnlyOne": "Please only select one option for draft and spillage results.",
  "preTestSpillageClosedDoorOnlyOne": "Please only select one option for draft and spillage results.",
  "preTestSpillageClosedDoor2OnlyOne": "Please only select one option for draft and spillage results.",
  "preTestDraftOpenDoorOnlyOne": "Please only select one option for draft and draft results.",
  "preTestDraftOpenDoor2OnlyOne": "Please only select one option for draft and draft results.",
  "preTestDraftClosedDoorOnlyOne": "Please only select one option for draft and draft results.",
  "preTestDraftClosedDoor2OnlyOne": "Please only select one option for draft and draft results.",
  "postTestSpillageOpenDoorOnlyOne": "Please only select one option for draft and spillage results.*1",
  "postTestSpillageOpenDoor2OnlyOne": "Please only select one option for draft and spillage results.*2",
  "postTestSpillageClosedDoorOnlyOne": "Please only select one option for draft and spillage results.*3",
  "postTestSpillageClosedDoor2OnlyOne": "Please only select one option for draft and spillage results.*4",
  "postTestDraftOpenDoorOnlyOne": "Please only select one option for draft and draft results.*5",
  "postTestDraftOpenDoor2OnlyOne": "Please only select one option for draft and draft results.*6",
  "postTestDraftClosedDoorOnlyOne": "Please only select one option for draft and draft results.*7",
  "postTestDraftClosedDoor2OnlyOne": "Please only select one option for draft and draft results.*8",
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "preTestPrimary_wallFurnace": () => ({
      validate: () => {
        const primaryHeatSourceAppliance = ["preTestPrimary_wallFurnace", "preTestPrimary_floorFurnace", "preTestPrimary_fau", "preTestPrimary_freestandingHeater"];
        const count = primaryHeatSourceAppliance.filter(appliance => !!getValues(appliance)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimaryHeatSourceAppliance'];
      },
    }),
    "preTestPrimary_naturalDraft": () => ({
      validate: () => {
        const primaryHeatSourceCombType = ["preTestPrimary_naturalDraft", "preTestPrimary_inducedDraft", "preTestPrimary_closed"];
        const count = primaryHeatSourceCombType.filter(appliance => !!getValues(appliance)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimaryHeatSourceCombType'];
      },
    }),
    "preTestSecondary_wallFurnace": () => ({
      validate: () => {
        const secondaryHeatSourceAppliance = ["preTestSecondary_wallFurnace", "preTestSecondary_floorFurnace", "preTestSecondary_fau", "preTestSecondary_ventedSpaceHeater"];
        const count = secondaryHeatSourceAppliance.filter(appliance => !!getValues(appliance)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondaryHeatSourceAppliance'];
      },
    }),
    "preTestSecondary_naturalDraft": () => ({
      validate: () => {
        const secondaryHeatSourceCombType = ["preTestSecondary_naturalDraft", "preTestSecondary_inducedDraft", "preTestSecondary_closed"];
        const count = secondaryHeatSourceCombType.filter(appliance => !!getValues(appliance)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondaryHeatSourceCombType'];
      },
    }),
    "primaryConditions_1_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_1_yes", "primaryConditions_1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_1'];
      },
    }),
    "primaryConditions_2_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_2_yes", "primaryConditions_2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_2'];
      },
    }),
    "primaryConditions_3_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_3_yes", "primaryConditions_3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_3'];
      },
    }),
    "primaryConditions_4_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_4_yes", "primaryConditions_4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_4'];
      },
    }),
    "primaryConditions_5_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_5_yes", "primaryConditions_5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_5'];
      },
    }),
    "primaryConditions_6_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_6_yes", "primaryConditions_6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_6'];
      },
    }),
    "primaryConditions_7_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_7_yes", "primaryConditions_7_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_7'];
      },
    }),
    "primaryConditions_8_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_8_yes", "primaryConditions_8_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_8'];
      },
    }),
    "primaryConditions_9_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_9_yes", "primaryConditions_9_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_9'];
      },
    }),
    "primaryConditions_10_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_10_yes", "primaryConditions_10_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_10'];
      },
    }),
    "secondaryConditions_1_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_1_yes", "secondaryConditions_1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_1'];
      },
    }),
    "secondaryConditions_2_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_2_yes", "secondaryConditions_2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_2'];
      },
    }),
    "secondaryConditions_3_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_3_yes", "secondaryConditions_3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_3'];
      },
    }),
    "secondaryConditions_4_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_4_yes", "secondaryConditions_4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_4'];
      },
    }),
    "secondaryConditions_5_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_5_yes", "secondaryConditions_5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_5'];
      },
    }),
    "secondaryConditions_6_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_6_yes", "secondaryConditions_6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_6'];
      },
    }),
    "secondaryConditions_7_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_7_yes", "secondaryConditions_7_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_7'];
      },
    }),
    "secondaryConditions_8_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_8_yes", "secondaryConditions_8_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_8'];
      },
    }),
    "secondaryConditions_9_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_9_yes", "secondaryConditions_9_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_9'];
      },
    }),
    "secondaryConditions_10_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_10_yes", "secondaryConditions_10_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_10'];
      },
    }),
    "primaryCorrections_2_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_2_yes", "primaryCorrections_2_no", "primaryCorrections_2_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_2'];
      },
    }),
    "primaryCorrections_3_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_3_yes", "primaryCorrections_3_no", "primaryCorrections_3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_3'];
      },
    }),
    "primaryCorrections_4_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_4_yes", "primaryCorrections_4_no", "primaryCorrections_4_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_4'];
      },
    }),
    "primaryCorrections_5_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_5_yes", "primaryCorrections_5_no", "primaryCorrections_5_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_5'];
      },
    }),
    "primaryCorrections_7_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_7_yes", "primaryCorrections_7_no", "primaryCorrections_7_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_7'];
      },
    }),
    "primaryCorrections_8_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_8_yes", "primaryCorrections_8_no", "primaryCorrections_8_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_8'];
      },
    }),
    "primaryCorrections_9_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_9_yes", "primaryCorrections_9_no", "primaryCorrections_9_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_9'];
      },
    }),
    "primaryCorrections_10_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_10_yes", "primaryCorrections_10_no", "primaryCorrections_10_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_10'];
      },
    }),
    "secondaryCorrections_2_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_2_yes", "secondaryCorrections_2_no", "secondaryCorrections_2_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_2'];
      },
    }),
    "secondaryCorrections_3_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_3_yes", "secondaryCorrections_3_no", "secondaryCorrections_3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_3'];
      },
    }),
    "secondaryCorrections_4_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_4_yes", "secondaryCorrections_4_no", "secondaryCorrections_4_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_4'];
      },
    }),
    "secondaryCorrections_5_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_5_yes", "secondaryCorrections_5_no", "secondaryCorrections_5_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_5'];
      },
    }),
    "secondaryCorrections_7_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_7_yes", "secondaryCorrections_7_no", "secondaryCorrections_7_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_7'];
      },
    }),
    "secondaryCorrections_8_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_8_yes", "secondaryCorrections_8_no", "secondaryCorrections_8_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_8'];
      },
    }),
    "secondaryCorrections_9_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_9_yes", "secondaryCorrections_9_no", "secondaryCorrections_9_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_9'];
      },
    }),
    "secondaryCorrections_10_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_10_yes", "secondaryCorrections_10_no", "secondaryCorrections_10_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_10'];
      },
    }),
    "preTestPrimaryOpenDoorPPM_nf": () => ({
      validate: () => {
        const options = ["preTestPrimaryOpenDoorPPM_nf", "preTestPrimaryOpenDoorPPM_hazard", "preTestPrimaryOpenDoorPPM_fail", "preTestPrimaryOpenDoorPPM_exhaustPort", "preTestPrimaryOpenDoorPPM_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestOpenDoorPrimaryPPM'];
      },
    }),
    "preTestSecondaryOpenDoorPPM_nf": () => ({
      validate: () => {
        const options = ["preTestSecondaryOpenDoorPPM_nf", "preTestSecondaryOpenDoorPPM_hazard", "preTestSecondaryOpenDoorPPM_fail", "preTestSecondaryOpenDoorPPM_exhaustPort", "preTestSecondaryOpenDoorPPM_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestOpenDoorSecondaryPPM'];
      },
    }),
    "preTestPrimaryClosedDoorPPM_nf": () => ({
      validate: () => {
        const options = ["preTestPrimaryClosedDoorPPM_nf", "preTestPrimaryClosedDoorPPM_hazard", "preTestPrimaryClosedDoorPPM_fail", "preTestPrimaryClosedDoorPPM_exhaustPort", "preTestPrimaryClosedDoorPPM_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestClosedDoorPrimaryPPM'];
      },
    }),
    "preTestSecondaryClosedDoorPPM_nf": () => ({
      validate: () => {
        const options = ["preTestSecondaryClosedDoorPPM_nf", "preTestSecondaryClosedDoorPPM_hazard", "preTestSecondaryClosedDoorPPM_fail", "preTestSecondaryClosedDoorPPM_exhaustPort", "preTestSecondaryClosedDoorPPM_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestClosedDoorSecondaryPPM'];
      },
    }),
    "postTestPrimaryOpenDoorPPM_nf": () => ({
      validate: () => {
        const options = ["postTestPrimaryOpenDoorPPM_nf", "postTestPrimaryOpenDoorPPM_hazard", "postTestPrimaryOpenDoorPPM_fail", "postTestPrimaryOpenDoorPPM_exhaustPort", "postTestPrimaryOpenDoorPPM_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestOpenDoorPrimaryPPM'];
      },
    }),
    "postTestSecondaryOpenDoorPPM_nf": () => ({
      validate: () => {
        const options = ["postTestSecondaryOpenDoorPPM_nf", "postTestSecondaryOpenDoorPPM_hazard", "postTestSecondaryOpenDoorPPM_fail", "postTestSecondaryOpenDoorPPM_exhaustPort", "postTestSecondaryOpenDoorPPM_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestOpenDoorSecondaryPPM'];
      },
    }),
    "postTestPrimaryClosedDoorPPM_nf": () => ({
      validate: () => {
        const options = ["postTestPrimaryClosedDoorPPM_nf", "postTestPrimaryClosedDoorPPM_hazard", "postTestPrimaryClosedDoorPPM_fail", "postTestPrimaryClosedDoorPPM_exhaustPort", "postTestPrimaryClosedDoorPPM_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestClosedDoorPrimaryPPM'];
      },
    }),
    "postTestSecondaryClosedDoorPPM_nf": () => ({
      validate: () => {
        const options = ["postTestSecondaryClosedDoorPPM_nf", "postTestSecondaryClosedDoorPPM_hazard", "postTestSecondaryClosedDoorPPM_fail", "postTestSecondaryClosedDoorPPM_exhaustPort", "postTestSecondaryClosedDoorPPM_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestClosedDoorSecondaryPPM'];
      },
    }),
    "preTestSpillageOpenDoor_pass": () => ({
      validate: () => {
        const options = ["preTestSpillageOpenDoor_pass", "preTestSpillageOpenDoor_fail", "preTestSpillageOpenDoor_nf", "preTestSpillageOpenDoor_hazard", "preTestSpillageOpenDoor_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestSpillageOpenDoorOnlyOne'];
      },
    }),
    "preTestSpillageOpenDoor2_pass": () => ({
      validate: () => {
        const options = ["preTestSpillageOpenDoor2_pass", "preTestSpillageOpenDoor2_fail", "preTestSpillageOpenDoor2_nf", "preTestSpillageOpenDoor2_hazard", "preTestSpillageOpenDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestSpillageOpenDoor2OnlyOne'];
      },
    }),
    "preTestSpillageClosedDoor_pass": () => ({
      validate: () => {
        const options = ["preTestSpillageClosedDoor_pass", "preTestSpillageClosedDoor_fail", "preTestSpillageClosedDoor_nf", "preTestSpillageClosedDoor_hazard", "preTestSpillageClosedDoor_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestSpillageClosedDoorOnlyOne'];
      },
    }),
    "preTestSpillageClosedDoor2_pass": () => ({
      validate: () => {
        const options = ["preTestSpillageClosedDoor2_pass", "preTestSpillageClosedDoor2_fail", "preTestSpillageClosedDoor2_nf", "preTestSpillageClosedDoor2_hazard", "preTestSpillageClosedDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestSpillageClosedDoor2OnlyOne'];
      },
    }),
    "preTestDraftOpenDoor1_pass": () => ({
      validate: () => {
        const options = ["preTestDraftOpenDoor1_pass", "preTestDraftOpenDoor1_fail", "preTestDraftOpenDoor1_nf", "preTestDraftOpenDoor1_hazard", "preTestDraftOpenDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestDraftOpenDoorOnlyOne'];
      },
    }),
    "preTestDraftOpenDoor2_pass": () => ({
      validate: () => {
        const options = ["preTestDraftOpenDoor2_pass", "preTestDraftOpenDoor2_fail", "preTestDraftOpenDoor2_nf", "preTestDraftOpenDoor2_hazard", "preTestDraftOpenDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestDraftOpenDoor2OnlyOne'];
      },
    }),
    "preTestDraftClosedDoor1_pass": () => ({
      validate: () => {
        const options = ["preTestDraftClosedDoor1_pass", "preTestDraftClosedDoor1_fail", "preTestDraftClosedDoor1_nf", "preTestDraftClosedDoor1_hazard", "preTestDraftClosedDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestDraftClosedDoorOnlyOne'];
      },
    }),
    "preTestDraftClosedDoor2_pass": () => ({
      validate: () => {
        const options = ["preTestDraftClosedDoor2_pass", "preTestDraftClosedDoor2_fail", "preTestDraftClosedDoor2_nf", "preTestDraftClosedDoor2_hazard", "preTestDraftClosedDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestDraftClosedDoor2OnlyOne'];
      },
    }),
    "postTestSpillageOpenDoor1_pass": () => ({
      validate: () => {
        const options = ["postTestSpillageOpenDoor1_pass", "postTestSpillageOpenDoor1_fail", "postTestSpillageOpenDoor1_nf", "postTestSpillageOpenDoor1_hazard", "postTestSpillageOpenDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSpillageOpenDoorOnlyOne'];
      },
    }),
    "postTestSpillageOpenDoor2_pass": () => ({
      validate: () => {
        const options = ["postTestSpillageOpenDoor2_pass", "postTestSpillageOpenDoor2_fail", "postTestSpillageOpenDoor2_nf", "postTestSpillageOpenDoor2_hazard", "postTestSpillageOpenDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSpillageOpenDoor2OnlyOne'];
      },
    }),
    "postTestSpillageClosedDoor1_pass": () => ({
      validate: () => {
        const options = ["postTestSpillageClosedDoor1_pass", "postTestSpillageClosedDoor1_fail", "postTestSpillageClosedDoor1_nf", "postTestSpillageClosedDoor1_hazard", "postTestSpillageClosedDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSpillageClosedDoorOnlyOne'];
      },
    }),
    "postTestSpillageClosedDoor2_pass": () => ({
      validate: () => {
        const options = ["postTestSpillageClosedDoor2_pass", "postTestSpillageClosedDoor2_fail", "postTestSpillageClosedDoor2_nf", "postTestSpillageClosedDoor2_hazard", "postTestSpillageClosedDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSpillageClosedDoor2OnlyOne'];
      },
    }),
    "postTestDraftOpenDoor1_pass": () => ({
      validate: () => {
        const options = ["postTestDraftOpenDoor1_pass", "postTestDraftOpenDoor1_fail", "postTestDraftOpenDoor1_nf", "postTestDraftOpenDoor1_hazard", "postTestDraftOpenDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestDraftOpenDoorOnlyOne'];
      },
    }),
    "postTestDraftOpenDoor2_pass": () => ({
      validate: () => {
        const options = ["postTestDraftOpenDoor2_pass", "postTestDraftOpenDoor2_fail", "postTestDraftOpenDoor2_nf", "postTestDraftOpenDoor2_hazard", "postTestDraftOpenDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestDraftOpenDoor2OnlyOne'];
      },
    }),
    "postTestDraftClosedDoor1_pass": () => ({
      validate: () => {
        const options = ["postTestDraftClosedDoor1_pass", "postTestDraftClosedDoor1_fail", "postTestDraftClosedDoor1_nf", "postTestDraftClosedDoor1_hazard", "postTestDraftClosedDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestDraftClosedDoorOnlyOne'];
      },
    }),
    "postTestDraftClosedDoor2_pass": () => ({
      validate: () => {
        const options = ["postTestDraftClosedDoor2_pass", "postTestDraftClosedDoor2_fail", "postTestDraftClosedDoor2_nf", "postTestDraftClosedDoor2_hazard", "postTestDraftClosedDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestDraftClosedDoor2OnlyOne'];
      },
    }),
  };
};

export default useValidation;
